import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { HEADER_SIZE } from "@styles/variables";
import { grayScale, pink } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";
import { Z_INDEX } from "@enkor/design/variables";

export const AVATAR_SIZE = 20;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  /* HACK: Height가 body부터 명확히 정해져 있지 않기 때문에 하위 요소에도 모두 min-height view height를 적용해주어야 컨텐츠 크기가 작을 때도 꽉 채워진 화면을 볼 수 있음.
  + Contents가 들어가는 곳은 Header HEIGHT가 제외된 크기 */
  height: calc(100% - ${HEADER_SIZE.HEIGHT}px);
  min-height: calc(100vh - ${HEADER_SIZE.HEIGHT}px);
  min-height: calc((var(--vh, 1vh) * 100) - ${HEADER_SIZE.HEIGHT}px);
  padding-bottom: 80px;
`;

export const CustomDivider = styled.div`
  width: calc(100% - 32px) !important;
  height: 1px;
  margin: 8px auto;
  padding: 0 16px;

  background-color: ${grayScale[300]};
`;

export const ProjectNotice = styled(motion.button)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 8px 16px;
  background-color: ${pink.main};

  z-index: 0;
`;

export const ProjectNoticeTitle = styled(Typo.Heading)`
  line-height: 22px;
  color: ${grayScale.white};
`;

export const ProjectNoticeContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ProjectLink = styled(Typo.Text)`
  color: ${grayScale.white};
`;
